import { Alert } from '@mui/material'
import { Fragment } from 'react'

export const FieldCardErrors = ({ messages }: { messages: string[] }) =>
  messages.length > 0 ? (
    <Alert severity="error">
      {messages.map(message => (
        <Fragment key={message}>
          {message}
          <br />
        </Fragment>
      ))}
    </Alert>
  ) : null
